import { Button, Card, CardContent, Label, Switch } from '@repo/shadcn';
import { Loader2Icon } from 'lucide-react';
import { useFormContext } from 'react-hook-form';

import { TAddPaymentForm } from './add-payment-form.schema';
import { useCartContext } from './cart.context';

export const SubmitOrder = () => {
    const { handleSubmit, watch } = useFormContext<TAddPaymentForm>();
    const {
        handleSubmitCart,
        handleSubmitCartWithPrint,
        isAddItemToCartLoading,
        isActiveCartLoading,
        isActiveCartFetching,
        activeCart,
        isConfirmOrderMultiPaymentLoading,
        showDiscount,
        setShowDiscount,
    } = useCartContext();

    const payments = watch('payments');

    const totalCartItems = activeCart?.data?.items?.length ?? 0;

    const isLoading = isConfirmOrderMultiPaymentLoading;

    const isDisabled = () => {
        if (
            isAddItemToCartLoading ||
            isActiveCartFetching ||
            isActiveCartLoading ||
            totalCartItems === 0
        ) {
            return true;
        }

        // Check if paid amount is less than total price and no customer is selected
        const currentPaidAmount =
            payments?.reduce(
                (acc, value) => acc + Number(value?.amount ?? 0),
                0,
            ) ?? 0;

        const totalPrice = activeCart?.data?.info?.total_price ?? 0;

        const customerId = activeCart?.data?.info?.customer_id;

        if (currentPaidAmount < totalPrice && !customerId) {
            return true;
        }

        return false;
    };

    return (
        <Card
            className={'rounded-bl-0 rounded-br-0 sticky bottom-0 z-10 w-full'}
        >
            <CardContent className="flex flex-col gap-2 px-3 pt-2">
                <div className="flex items-center gap-2">
                    <Switch
                        id="show-discount-checkbox"
                        checked={showDiscount}
                        onCheckedChange={(checked) =>
                            setShowDiscount(checked as boolean)
                        }
                    />
                    <Label htmlFor="show-discount-checkbox">
                        Show discount
                    </Label>
                </div>
                <div className="flex justify-between gap-2">
                    <Button
                        type="button"
                        className="w-full bg-green-600"
                        variant={'default'}
                        disabled={isDisabled()}
                        onClick={handleSubmit(handleSubmitCart)}
                    >
                        {isLoading ? (
                            <Loader2Icon className={'size-4 animate-spin'} />
                        ) : (
                            'Save'
                        )}
                    </Button>
                    <Button
                        type="button"
                        className="w-full"
                        disabled={isDisabled()}
                        onClick={handleSubmit(handleSubmitCartWithPrint)}
                    >
                        {isLoading ? (
                            <Loader2Icon className={'size-4 animate-spin'} />
                        ) : (
                            'Print'
                        )}
                    </Button>
                </div>
            </CardContent>
        </Card>
    );
};

SubmitOrder.displayName = 'SubmitOrder';
